import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white px-6 py-4" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "mt-3 font-semibold" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 font-semibold" }, "Ответ 1С:", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "Заказ (ID): " + _toDisplayString(_ctx.item.id), 1),
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.state.is_loading,
        onClick: _ctx.resend
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Переотправить ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    _createElementVNode("p", _hoisted_4, "Дата забора: " + _toDisplayString(_ctx.item.take_date), 1),
    _createElementVNode("p", null, "Номер: " + _toDisplayString(_ctx.item.number), 1),
    _createElementVNode("p", null, "Компания: " + _toDisplayString(_ctx.item.company), 1),
    _createElementVNode("p", null, "Курьер: " + _toDisplayString(_ctx.item.courier), 1),
    _createElementVNode("p", null, "Кол-во накладных: " + _toDisplayString(_ctx.item.invoices_count), 1),
    _createElementVNode("p", null, "Комментарий: " + _toDisplayString(_ctx.item.comment), 1),
    _createElementVNode("p", null, "Менеджер: " + _toDisplayString(_ctx.item.manager), 1),
    _createElementVNode("p", _hoisted_5, "Отправитель: " + _toDisplayString(_ctx.item.sender.title), 1),
    _createElementVNode("p", _hoisted_6, "Город: " + _toDisplayString(_ctx.item.sender.city), 1),
    _createElementVNode("p", null, "Страна: " + _toDisplayString(_ctx.item.sender.country), 1),
    _createElementVNode("p", null, "Полный адрес: " + _toDisplayString(_ctx.item.sender.full_address), 1),
    _createElementVNode("p", null, "Полное имя: " + _toDisplayString(_ctx.item.sender.full_name), 1),
    _createElementVNode("p", null, [
      (_ctx.item.sender.additional_phone)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Телефон: " + _toDisplayString(_ctx.item.sender.phone) + ", " + _toDisplayString(_ctx.item.sender.additional_phone), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Телефон: " + _toDisplayString(_ctx.item.sender.phone), 1)
          ], 64))
    ]),
    _createElementVNode("p", null, "Комментарий: " + _toDisplayString(_ctx.item.sender.comment), 1),
    _createElementVNode("p", null, "Дом: " + _toDisplayString(_ctx.item.sender.house), 1),
    _createElementVNode("p", null, "Индекс: " + _toDisplayString(_ctx.item.sender.index), 1),
    _createElementVNode("p", null, "Офис: " + _toDisplayString(_ctx.item.sender.office), 1),
    _createElementVNode("p", null, "Улица: " + _toDisplayString(_ctx.item.sender.street), 1),
    _hoisted_7,
    (JSON.parse(_ctx.item.response_1c))
      ? (_openBlock(), _createElementBlock("pre", _hoisted_8, "            " + _toDisplayString(JSON.parse(_ctx.item.response_1c)) + "\n        ", 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString((_ctx.item.response_1c && decodeURI(_ctx.item.response_1c)) ||
                _ctx.item.response_1c ||
                'Нет данных'), 1))
  ]))
}